import React from 'react';
import { IUserNotificationDetail } from '@Shared.Angular/@types/core/contracts/queryModel/notifications/userNotificationDetail';
import { getService } from '@Shared.Angular/flowingly.hooks/useService';
import { TextButton } from '@Shared.Angular/flowingly.components/buttons/TextButton';
import IconButton from '@Shared.Angular/flowingly.components/buttons/IconButton';

type Props = {
  notification: IUserNotificationDetail;
  onDismiss: (notification: IUserNotificationDetail) => void;
  onRead: (notification: IUserNotificationDetail) => void;
};

export const UserNotificationItem = ({
  notification,
  onDismiss,
  onRead
}: Props) => {
  const sanitizedComment = getService('$sanitize')(notification.comment);
  const commentWithMentions = getService(
    'flowinglyMentionService'
  ).transformMentionTag(sanitizedComment);
  const notificationDate = new Intl.DateTimeFormat(undefined, {
    day: '2-digit',
    month: 'short'
  }).format(new Date(String(notification.commentDate)));

  return (
    <div
      className={`${
        notification.read ? 'read' : 'unread'
      } user-notification-item`}
    >
      <div className="user-notification-item__header">
        <div className="user-notification-item__header__title">
          {notification.header}
        </div>
        <div className="user-notification-item__header__date">
          {notificationDate}
        </div>
        <IconButton
          iconClass="fa-xmark"
          title="Dismiss"
          onClick={() => onDismiss(notification)}
        />
      </div>
      <div className="user-notification-item__body">
        <div dangerouslySetInnerHTML={{ __html: commentWithMentions }} />
        <TextButton
          type="secondary"
          onClick={() => onRead(notification)}
          text="View"
        />
      </div>
    </div>
  );
};
